/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BasePageFragment} from '@amblique/contentful/app/contentful/fragments/page/base-page.fragment';
import {AccordionFragment} from '@amblique/contentful/app/contentful/fragments/accordion/accordion.fragment';
import {AccordionPanelFragment} from '@amblique/contentful/app/contentful/fragments/accordion-panel/accordion-panel.fragment';
import {BlogFragment} from '@amblique/contentful/app/contentful/fragments/blog/blog.fragment';
import {BlogGridFragment} from '@amblique/contentful/app/contentful/fragments/blog-grid/blog-grid.fragment';
import {BreadcrumbFragment} from '@amblique/contentful/app/contentful/fragments/breadcrumb/breadcrumb.fragment';
import {CardFragment} from '@amblique/contentful/app/contentful/fragments/card/card.fragment';
import {CarouselFragment} from '@amblique/contentful/app/contentful/fragments/carousel/carousel.fragment';
import {ContainerFragment} from '@amblique/contentful/app/contentful/fragments/container/container.fragment';
import {EmbedPanelFragment} from '@amblique/contentful/app/contentful/fragments/embed-panel/embed-panel.fragment';
import {FeatureListFragment} from '@amblique/contentful/app/contentful/fragments/feature-list/feature-list.fragment';
import {HeroBannerFragment} from '@amblique/contentful/app/contentful/fragments/hero-banner/hero-banner.fragment';
import {IconSetFragment} from '@amblique/contentful/app/contentful/fragments/icon-set/icon-set.fragment';
import {ImageFragment} from '@amblique/contentful/app/contentful/fragments/image/image.fragment';
import {LinkFragment} from '@amblique/contentful/app/contentful/fragments/link/link.fragment';
import {MediaCarouselFragment} from '@amblique/contentful/app/contentful/fragments/media-carousel/media-carousel.fragment';
import {RichTextBlockFragment} from '@amblique/contentful/app/contentful/fragments/rich-text-block/rich-text-block.fragment';
import {SectionPanelFragment} from '@amblique/contentful/app/contentful/fragments/section-panel/section-panel.fragment';
import {SeoFragment} from '@amblique/contentful/app/contentful/fragments/seo/seo.fragment';
import {ShowroomDetailsFragment} from '@amblique/contentful/app/contentful/fragments/showroom-details/showroom-details.fragment';
import {SplitPanelDoubleImageBlockFragment} from '@amblique/contentful/app/contentful/fragments/split-panel-double-image-block/split-panel-double-image-block.fragment';
import {TeaserTileBlockFragment} from '@amblique/contentful/app/contentful/fragments/teaser-tile-block/teaser-tile-block.fragment';
import {VideoFragment} from '@amblique/contentful/app/contentful/fragments/video/video.fragment';

export const FullPageFragment = gql`
  ${AccordionFragment}
  ${AccordionPanelFragment}
  ${BasePageFragment}
  ${BlogFragment}
  ${BlogGridFragment}
  ${BreadcrumbFragment}
  ${CardFragment}
  ${CarouselFragment}
  ${ContainerFragment}
  ${EmbedPanelFragment}
  ${FeatureListFragment}
  ${HeroBannerFragment}
  ${IconSetFragment}
  ${ImageFragment}
  ${LinkFragment}
  ${MediaCarouselFragment}
  ${RichTextBlockFragment}
  ${SectionPanelFragment}
  ${SeoFragment}
  ${ShowroomDetailsFragment}
  ${SplitPanelDoubleImageBlockFragment}
  ${TeaserTileBlockFragment}
  ${VideoFragment}

  fragment FullPageFragment on Page {
    ...BasePageFragment

    mainRegionCollection {
      items {
        __typename
        ... on Accordion {
          ...AccordionFragment
        }
        ... on AccordionPanel {
          ...AccordionPanelFragment
        }
        ... on Blog {
          ...BlogFragment
        }
        ... on BlogGrid {
          ...BlogGridFragment
        }
        ... on Breadcrumb {
          ...BreadcrumbFragment
        }
        ... on Card {
          ...CardFragment
        }
        ... on Carousel {
          ...CarouselFragment
        }
        ... on Container {
          ...ContainerFragment
        }
        ... on EmbedPanel {
          ...EmbedPanelFragment
        }
        ... on FeatureList {
          ...FeatureListFragment
        }
        ... on HeroBanner {
          ...HeroBannerFragment
        }
        ... on IconSet {
          ...IconSetFragment
        }
        ... on Image {
          ...ImageFragment
        }
        ... on Link {
          ...LinkFragment
        }
        ... on MediaCarousel {
          ...MediaCarouselFragment
        }
        ... on RichTextBlock {
          ...RichTextBlockFragment
        }
        ... on SectionPanel {
          ...SectionPanelFragment
        }
        ... on ShowroomDetails {
          ...ShowroomDetailsFragment
        }
        ... on SplitPanelDoubleImageBlock {
          ...SplitPanelDoubleImageBlockFragment
        }
        ... on TeaserTileBlock {
          ...TeaserTileBlockFragment
        }
        ... on Video {
          ...VideoFragment
        }
      }
    }
    seo {
      ...SeoFragment
    }
  }
`;
